module.exports = __webpack_public_path__ + "static/img/Repurchase.a9e11b71.png";